import { render, staticRenderFns } from "./IconShoppingCart.vue?vue&type=template&id=1d5a5384"
import script from "./IconShoppingCart.vue?vue&type=script&lang=js"
export * from "./IconShoppingCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports